import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { billingV2Post } from '@/lib/api/clients/billing-v2';
import { billingV2Endpoints } from '@/lib/api/endpoints';
import type { CreatePaymentScheduleInput, PaymentSchedule } from '@/types/paymentSchedule';
import { invalidatePaymentScheduleEffects } from './invalidatePaymentScheduleEffects';

export function useCreatePaymentSchedule() {
  const queryClient = useQueryClient();
  return useApiMutation<PaymentSchedule, CreatePaymentScheduleInput>({
    mutationFn: (dto) =>
      billingV2Post<PaymentSchedule, CreatePaymentScheduleInput>(
        billingV2Endpoints.paymentScheduleCreate(),
        dto,
      ),
    onSuccess: (schedule) => {
      invalidatePaymentScheduleEffects(queryClient, schedule.jobId);
      toast.success('Payment schedule created');
    },
  });
}
